import { AppBar, Box, Button } from "@material-ui/core";
import Link from "@material-ui/core/Link";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import { useMediaQuery, Else, getHistory, Show } from "@shoothill/core";
import { AppUrls } from "AppUrls";
import { Stores, StoresContext } from "Globals/Stores";
import { useObserver } from "mobx-react-lite";
import React, { useContext } from "react";
import { Link as RouterLink } from "react-router-dom";

interface LinkButonProps {
    linkText: string;
    to?: any;
    onClick?: any;
}
export const LinkButton: React.FC<LinkButonProps> = (props: LinkButonProps) => {
    let component: any = RouterLink;
    if (props.to === null || props.to === undefined) {
        component = Box;
    }
    return (
        <Button color="inherit" style={{ margin: "0 7px" }}>
            <Link color={"inherit"} component={component} to={props.to} onClick={props.onClick}>
                <Typography style={{ fontSize: "14px", fontWeight: "bold" }} color={"inherit"} variant={"button"}>
                    {props.linkText}
                </Typography>
            </Link>
        </Button>
    );
};
export const Header: React.FC = () => {
    const storesContext = useContext<Stores>(StoresContext);
    const isMobile: boolean = useMediaQuery("screen and (max-width: 767px)") ? true : false;
    const loggedInList = (
        <>
            <Show if={storesContext.Domain.AccountStore.isInRole("admin")}>
                <LinkButton linkText={"Applicants"} to={AppUrls.Client.Admin.AdminHome} />
                <LinkButton linkText={"System"} to={AppUrls.Client.Admin.AdminManageUsers} />
                <Else>
                    <LinkButton linkText={"Dashboard"} to={AppUrls.Client.Dashboard} />
                </Else>
            </Show>
            <LinkButton linkText={"Logout"} onClick={() => storesContext.Domain.AccountStore.Logout()} />
        </>
    );

    const loggedOutList = (
        <>
            <LinkButton linkText={"Login"} to={AppUrls.Client.Account.Login} />
            {/* <LinkButton linkText={"Examples"} to={AppUrls.Client.Samples} />
            <LinkButton linkText={"Register"} to={AppUrls.Client.Account.Register} />
            <LinkButton linkText={"Test Page"} to={AppUrls.Client.Test} /> */}
        </>
    );

    return useObserver(() => (
        <>
            <AppBar position={"sticky"} color={"secondary"}>
                <Toolbar>
                    <Box flexGrow={1} paddingY={"30px"} flexDirection={"row"} display={"flex"}>
                        <img
                            src="/hightownLogo.svg"
                            alt="Hightown"
                            className="logoHightown"
                            style={isMobile ? { width: "100px" } : { cursor: "pointer", width: "179px" }}
                            onClick={() => getHistory().push("/")}
                        />
                        {!isMobile && (
                            <Box paddingLeft={"60px"} display={"flex"} alignItems={"center"}>
                                <Typography color={"inherit"} variant={"body1"}>
                                    {storesContext.Domain.AccountStore.isInRole("admin") ? "Customer Registration Portal" : "Customer Application Portal"}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                    <Show if={storesContext.Domain.AccountStore.IsLoggedIn}>
                        <Box>{loggedInList}</Box>
                        <Else>
                            <Box>{loggedOutList}</Box>
                        </Else>
                    </Show>
                </Toolbar>
            </AppBar>
        </>
    ));
};
